import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ResidenceSubType } from '../../residence.model';
import { Address } from 'src/app/user/user.model';

export interface VerifyAddressDialogData {
    address: Address;
    displayName: string;
}

@Component({
    selector: 'app-verify-address-dialog',
    templateUrl: './verify-address-dialog.component.html',
    styleUrls: ['./verify-address-dialog.component.scss'],
})
export class VerifyAddressDialogComponent {
    public selectedSubType: { value: ResidenceSubType; label: string } | null = null;

    public subTypeOptions: { value: ResidenceSubType; label: string }[] = [
        { value: 'RESIDENT', label: this.translateService.instant('pages.residences.subType.resident') },
        { value: 'NONRESIDENT', label: this.translateService.instant('pages.residences.subType.nonResident') },
    ];

    constructor(
        private translateService: TranslateService,
        public dialogRef: MatDialogRef<VerifyAddressDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: VerifyAddressDialogData,
    ) {
        this.selectedSubType = null;
    }

    get addressLine1(): string {
        const addr = this.data.address;
        if (!addr) return '';
        const parts = [];
        if (addr.unit) parts.push(`#${addr.unit}`);
        if (addr.number) parts.push(addr.number);
        if (addr.street) parts.push(addr.street);
        if (parts.length === 0 && addr.streetName) parts.push(addr.streetName);
        return parts.join(' ');
    }

    get addressLine2(): string {
        const addr = this.data.address;
        if (!addr) return '';
        return [addr.city, addr.province, addr.postCode].filter(Boolean).join(', ');
    }

    confirm(): void {
        this.dialogRef.close(this.selectedSubType?.value);
    }

    cancel(): void {
        this.dialogRef.close(null);
    }
}
